import { InternalError } from './internal.error';

export class JobNotFoundError extends InternalError {
  constructor(jobId: number, data: Record<string, unknown> = {}) {
    super('Job not found', { status: 404, data: { jobId, ...data } });
  }
}
